<template>
    <div class="hostetaile">
        <ul class="hostetaile-ul">
            <li class="hostetaile-li">
                <span>热线电话：</span>
                {{ Information.telephone }}
            </li>
            <li class="hostetaile-li">
                <span>工作时间：</span>
                {{ Information.workingtime }} 请在规定的时间内就诊
            </li>
            <li class="hostetaile-li">
                <span>来院路线：</span>
                {{ Information.hosaddress }}
            </li>
        </ul>
    </div>
</template>

<script>
import { getintroducApi } from "@/api/resourceApi"
export default {
    data() {
        return {
            Information: {}
        }
    },
    created() {
        this.getintroducApiRequest()
    },
    methods: {
        async getintroducApiRequest() {
            let resout = await getintroducApi()
            this.Information = resout.data
        },
    }
}
</script>

<style lang="scss" scoped>
.hostetaile {
    padding: 30px;

    .hostetaile-ul {
        display: flex;
        flex-direction: column;

        .hostetaile-li {
            font-size: 12px;
            color: #414141;
            text-align: center;
            margin-bottom: 5px;

            span {
                font-size: 12px;
                color: #414141;
            }
        }
    }
}
</style>